import React, {FC, PropsWithChildren} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {
  DropdownItem,
  DropdownItemProps,
} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {DropdownItemSecondaryIcon} from '../../../common/dropdowns/dropdownItemSecondaryIcon';

/*
 * Props.
 */

interface CellsSortOptionsDropdownItemProps extends DropdownItemProps {}

/*
 * Component.
 */

export const CellsSortOptionsDropdownItem: FC<PropsWithChildren<CellsSortOptionsDropdownItemProps>> = (
  props,
) => {
  const theme = useUserTheme();
  const {isChecked, children} = props;
  return (
    <DropdownItem {...props} shouldHideCheckmark shouldReserveRightIcon>
      <DropdownItemContent isChecked={isChecked}>{children}</DropdownItemContent>
      {isChecked && (
        <DropdownItemSecondaryIcon
          label={<Trans id="dropdown-sort-selected">Selected</Trans>}
          iconName="checkmarkSelectedSmall"
          color={theme.palette.blue.shade40}
        />
      )}
    </DropdownItem>
  );
};
